<template>
  <panel class="placeholder">
    <div class="header">
      <div class="icon" />
      <div class="title" />
    </div>

    <div class="metrics">
      <div class="metric" v-for="index in 3" :key="index">
        <metric-placeholder />
      </div>
    </div>
  </panel>
</template>

<script>
import Panel from '@/common/components/Panel'
import MetricPlaceholder from '@/common/components/MetricPlaceholder'

export default {
  name: 'ProjectOverviewPlaceholder',

  components: { Panel, MetricPlaceholder }
}
</script>

<style scoped lang="scss">
$placeholder-colour: #dbdee7;

.placeholder {
  width: 536px;

  .header {
    display: flex;
    align-items: center;
    padding-bottom: 24px;

    .icon {
      border-radius: 50%;
      background-color: $placeholder-colour;
      width: 32px;
      height: 32px;
      margin-right: 18px;
    }

    .title {
      width: 128px;
      height: 32px;
      background-color: $placeholder-colour;
      border-radius: 32px;
    }
  }

  .metrics {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .metric {
      margin-bottom: 20px;
      height: 52px;
      flex-basis: 33%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/ProjectOverviewPlaceholder.vue